/* Supabase configuration — loaded exclusively from environment variables.
   Never hardcode credentials here. Set VITE_SUPABASE_PROJECT_ID,
   VITE_SUPABASE_ANON_KEY, and VITE_API_BASE_URL in your .env file
   (see .env.example). */

export const projectId = import.meta.env.VITE_SUPABASE_PROJECT_ID as string;
export const publicAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

/**
 * Base URL for all server edge function calls.
 * Set VITE_API_BASE_URL in your .env to point at your deployed function,
 * e.g. https://<project-id>.supabase.co/functions/v1/<function-name>
 */
export const apiBaseUrl = (import.meta.env.VITE_API_BASE_URL as string) || '';
